import React, { useState } from "react";
import '../Bathroom/BathroomCleaningInfo.css'; // Import a CSS file for sofa cleaning styles
import ThumbImg from '../../Images/Serviceimg/thumbs-up.png';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'; // Import the expand icon
import RemoveImg from '../../Images/Serviceimg/remove.png'

const SofaCleaningInfo = () => {
    const [activeIndex, setActiveIndex] = useState(null); // State to manage the active question

    const handleToggle = (index) => {
        // Toggle the active index on click
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div className="cleaning-card">
            <div className="section-heading">Included</div>
            <ul className="service-list">
                <li className="service-item">
                    <span className="thumb-icon"><img src={ThumbImg} alt="" /></span>
                    Dry Vacuuming - Removal of accumulated dust particles, dirt, debris from all surfaces, corners, and crevices
                </li>
                <li className="service-item">
                    <span className="thumb-icon"><img src={ThumbImg} alt="" /></span>
                    Shampooing - Foam-based shampoo application on the sofa's fabric using a sponge
                </li>
                <li className="service-item">
                    <span className="thumb-icon"><img src={ThumbImg} alt="" /></span>
                    Wet Vacuuming - Cleaning the shampoo by vacuuming & wiping the water using a microfiber cloth
                </li>
                <li className="service-item">
                    <span className="thumb-icon"><img src={ThumbImg} alt="" /></span>
                    Drying - Please allow the sofa to dry completely for 4-5 hours under a fan
                </li>
            </ul>

            <div className="section-heading">Excluded</div>
            <ul className="service-list">
                <li className="service-item">
                    <span className="thumb-icon"><img src={RemoveImg} alt="" /></span>
                    <span className="service-item-text">Complete removal of ink stains</span>
                </li>
                <li className="service-item">
                    <span className="thumb-icon"><img src={RemoveImg} alt="" /></span>
                    <span className="service-item-text">Wet shampooing of leather/rexine/wooden sofa</span>
                </li>
                <li className="service-item">
                    <span className="thumb-icon"><img src={RemoveImg} alt="" /></span>
                    <span className="service-item-text">Cushions cleaning</span>
                </li>
            </ul>

            <div className="section-heading">Frequently Asked Questions</div>

            {[
                { question: "Is this service applicable for all types of sofa?", answer: "Yes, this service is applicable for all types of sofa. Our professionals carry out the necessary steps depending on the sofa's material." },
                { question: "Will this service include hard to reach areas like back and bottom of the sofa, crevices, etc.?", answer: "Yes, this service includes the back, bottom, and all hard-to-reach areas." },
            ].map((faq, index) => (
                <div className="faq-accordion" key={index}>
                    <div className="faq-question">
                        <div>{faq.question}</div>
                        <ExpandMoreIcon className={`faq-arrow ${activeIndex === index ? "rotate" : ""}`} onClick={() => handleToggle(index)} />
                    </div>
                    {activeIndex === index && (
                        <div className="faq-answer">
                            <div>{faq.answer}</div>
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default SofaCleaningInfo;
